.lot-input {
  input {
    height: 24px !important;
    line-height: 24px !important;
  }
}
